"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OderGroupCalcProfitUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
function calcGroupOrderPositionProfit(item, quote, quote_type, open_quote_price, basesTickers) {
    return item.reduce((sum1, item2) => {
        const tempTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === item2.base && item3.quote === quote);
        if (tempTicker !== undefined) {
            if (quote === quote_type) {
                return new trade_utils_lib_1.SafeDecimal(sum1)
                    .add(new trade_utils_lib_1.SafeDecimal(item2.qty).mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).sub(new trade_utils_lib_1.SafeDecimal(item2.avg_price).div(new trade_utils_lib_1.SafeDecimal(open_quote_price).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(open_quote_price).toNumber()))))
                    .toNumber();
            }
            else {
                const tempQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === quote && item3.quote === quote_type);
                if (tempQuoteTicker === undefined) {
                    return new trade_utils_lib_1.SafeDecimal(sum1)
                        .add(new trade_utils_lib_1.SafeDecimal(item2.qty).mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).sub(new trade_utils_lib_1.SafeDecimal(item2.avg_price))))
                        .toNumber();
                }
                else {
                    return new trade_utils_lib_1.SafeDecimal(sum1)
                        .add(new trade_utils_lib_1.SafeDecimal(item2.qty)
                        .mul(new trade_utils_lib_1.SafeDecimal(tempTicker.latest).sub(new trade_utils_lib_1.SafeDecimal(item2.avg_price).div(new trade_utils_lib_1.SafeDecimal(open_quote_price).equals(0) ? 1 : new trade_utils_lib_1.SafeDecimal(open_quote_price).toNumber())))
                        .mul(new trade_utils_lib_1.SafeDecimal(tempQuoteTicker.latest)))
                        .toNumber();
                }
            }
        }
        else {
            return sum1;
        }
    }, 0);
}
function calcGroupOrderSpotProfit(item, quote, basesTickers) {
    const USDDCoin = item.find((v) => v.base === "USDT");
    return item
        .filter((v) => v.base !== "USDT")
        .reduce((sum, item1) => {
        // base 对USDT价格
        const coinUTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item2) => item1.base === item2.base && item2.quote === "USDT");
        // base 对quote价格
        const baseQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item2) => item1.base === item2.base && item2.quote === quote);
        // quote 对USDT价格
        const quoteUTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item2) => quote === item2.base && item2.quote === "USDT");
        if (coinUTicker !== undefined) {
            return sum + coinUTicker.latest * Number(item1.amount);
        }
        else {
            if (baseQuoteTicker !== undefined && quoteUTicker !== undefined) {
                return sum + baseQuoteTicker.latest * quoteUTicker.latest * Number(item1.amount);
            }
            else {
                return sum;
            }
        }
    }, USDDCoin ? Number(USDDCoin.amount) : 0);
}
exports.OderGroupCalcProfitUtils = {
    _calcOrderGroupProfit(item, basesTickers) {
        item.exchangeGroupOrder.sub_order_list = item.exchangeGroupOrder.sub_order_list.map((item1) => {
            const _subOrderCurrentPositionValue = calcGroupOrderPositionProfit(item1.position_list, item1.quote, item.exchangeGroupOrder.quote_type, item1.open_quote_price, basesTickers);
            const _subOrderSpotValue = calcGroupOrderSpotProfit(item1.current_portfolio_list, item1.quote, basesTickers);
            let _dynamicMarginValue = 0;
            if (item1.quote !== item.exchangeGroupOrder.quote_type) {
                const tempQuoteTicker = basesTickers === null || basesTickers === void 0 ? void 0 : basesTickers.find((item3) => item3.base === item1.quote && item3.quote === item.exchangeGroupOrder.quote_type);
                if (tempQuoteTicker !== undefined) {
                    _dynamicMarginValue = new trade_utils_lib_1.SafeDecimal(item1.dynamic_margin)
                        .div(new trade_utils_lib_1.SafeDecimal(item1.open_quote_price === 0 ? 1 : item1.open_quote_price))
                        .mul(new trade_utils_lib_1.SafeDecimal(tempQuoteTicker.latest))
                        .toNumber();
                }
            }
            else {
                _dynamicMarginValue = Number(item1.dynamic_margin);
            }
            return Object.assign(Object.assign({}, item1), { totalProfit: _subOrderCurrentPositionValue + _subOrderSpotValue - Number(item1.quote_type_investment) - _dynamicMarginValue });
        });
        item.exchangeGroupOrder.totalProfit = item.exchangeGroupOrder.sub_order_list.reduce((sum, item1) => {
            return sum + item1.totalProfit;
        }, 0);
        item.exchangeGroupOrder.totalProfitPercent = new trade_utils_lib_1.SafeDecimal(item.exchangeGroupOrder.quote_type_investment).greaterThan(0)
            ? new trade_utils_lib_1.SafeDecimal(item.exchangeGroupOrder.totalProfit)
                .div(new trade_utils_lib_1.SafeDecimal(item.exchangeGroupOrder.quote_type_investment))
                .mul(100)
                .toNumber()
            : 0;
        return item;
    },
};
